import { serverNow } from '@/libs/serverTime'

export const ELAPSED_DEFAULTS = { warning: 90, danger: 180 };

function isValidPair(pair) {
  return !!pair && Number.isFinite(pair.warning) && Number.isFinite(pair.danger);
}

/**
 * Limites warning/danger de uma etapa a partir de state.step_alerts.
 * Sem disciplina, usa o par mais rígido entre as disciplinas do nó.
 */
export function resolveStepThresholds(map, stepKey, disciplineId = null) {
  if (!stepKey) return ELAPSED_DEFAULTS;

  if (disciplineId != null) {
    const pair = (map[String(disciplineId)] || {})[stepKey];
    return isValidPair(pair) ? pair : ELAPSED_DEFAULTS;
  }

  const pairs = Object.keys(map)
    .map((id) => (map[id] || {})[stepKey])
    .filter(isValidPair);

  if (!pairs.length) return ELAPSED_DEFAULTS;

  return pairs.reduce((a, b) => {
    if (b.warning !== a.warning) return b.warning < a.warning ? b : a;
    return b.danger < a.danger ? b : a;
  });
}

export default {
  data() {
    return {
      elapsedNow: serverNow(),
      elapsedTimer: null,
    };
  },

  mounted() {
    this.elapsedTimer = setInterval(() => {
      this.elapsedNow = serverNow();
    }, 1000);
  },

  beforeDestroy() {
    if (this.elapsedTimer) {
      clearInterval(this.elapsedTimer);
    }
  },

  methods: {
    elapsedHHMMSS(dateStr) {
      if (!dateStr) return '--:--:--';
      const now = this.elapsedNow;
      const diff = Math.max(0, Math.floor((now - new Date(dateStr).getTime()) / 1000));
      const h = Math.floor(diff / 3600);
      const m = Math.floor((diff % 3600) / 60);
      const s = diff % 60;
      return [h, m, s].map((v) => String(v).padStart(2, '0')).join(':');
    },

    elapsedBadgeClass(dateStr, stepKey = null, disciplineId = null) {
      if (!dateStr) return 'badge elapsed-badge elapsed-badge--ok';

      const { warning, danger } = this.elapsedThresholds(stepKey, disciplineId);
      const now = this.elapsedNow;
      const seconds = Math.floor((now - new Date(dateStr).getTime()) / 1000);

      if (seconds < warning) return 'badge elapsed-badge elapsed-badge--ok';
      if (seconds < danger) return 'badge elapsed-badge elapsed-badge--warning';
      return 'badge elapsed-badge elapsed-badge--danger';
    },

    elapsedThresholds(stepKey, disciplineId) {
      return resolveStepThresholds((this.$store && this.$store.state.step_alerts) || {}, stepKey, disciplineId);
    },
  },
};
